module.exports = __webpack_public_path__ + "static/media/5045_1100315980647_1561044_n.fd16e230.jpg";